module.exports = __webpack_public_path__ + "img/bell.06b43602.svg";